import React, { Component } from 'react';
import $ from "jquery";
import { ApiClient } from "../libs/apiClient";
import { SERVICE_RESPONSE } from '../libs/utils/Const';
import { TiposFigura } from '../components/NewOrder';
import AreYouAgreeModal from './AreYouAgreeModal';
import Select from 'react-select';
let apiClient = ApiClient.getInstance();

const customSelectStyles = {
    container: (base) => ({
        ...base,
        flex: 1,
        minWidth: 0
    }),
    control: (base, state) => ({
        ...base,
        minHeight: 40,
        height: 40,
        borderRadius: "0 4px 4px 0",
        borderColor: "#ced4da",
        backgroundColor: state.isDisabled ? "#e9ecef" : "#fff",
        boxShadow: "none",
        cursor: state.isDisabled ? "default" : "pointer",
        "&:hover": {
            borderColor: "#ced4da"
        }
    }),
    valueContainer: (base) => ({
        ...base,
        height: 40,
        padding: "0 12px"
    }),
    singleValue: (base) => ({
        ...base,
        color: "#495057",
        fontSize: "14px"
    }),
    input: (base) => ({
        ...base,
        color: "#495057",
        margin: 0,
        padding: 0
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: 40
    }),
    indicatorSeparator: () => ({
        display: "none"
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: "#8c959f"
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "#f1f3f5" : "#fff",
        color: "#212529",
        cursor: "pointer"
    })
};

class FiguraTransporteModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            // countries: [],
            states: [],
            parteTransporte: [],
            municipios: [],
            localidades: [],
            colonias: [],
            isSearchCodigoPostal: false,
            showAreYouAgreeModal: false,
            showPsw: false,
            sucursales: [],
            availableVehicles: []
        };
    }
    componentDidMount = async () => {
        await this.GetAllBranchOffices();
        this._handelBack();
        this.searchFiguraTransporteInfoCatalogs();
        this.GetStates('MEX');
        this.GetAdminDeliveriesData();

    }

    GetAdminDeliveriesData = async () => {
        const { enableSpinner, showAlert } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.getAdminDeliveriesData();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return;
        }

        await this.setState({
            availableVehicles: responseApi.data?.vehicles ?? [],
        });
    }
    GetAllBranchOffices = async () => {
        const data = {
            data: true
        }
        const listSucursales = await apiClient.getSucursales(data);
        this.setState({
            sucursales: listSucursales.data
        })
    }

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    }

    //#region Get catalogs SAT
    searchFiguraTransporteInfoCatalogs = async filter => {
        await this.callFiguraTransporteInfoCatalogs(filter);
    };
    callFiguraTransporteInfoCatalogs = async (filter = { action: 'parteTransporte' }) => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        let infoFiguraTransporteResponse = await apiClient.getFiguraTransporteInfoCatalogs(filter);
        enableSpinner(false);

        if (infoFiguraTransporteResponse.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                parteTransporte: infoFiguraTransporteResponse.data.catalog,
            });
        }
    };
    // OPTIMIZAR CONSULTA
    getCodigoPostalSAT = async (codigoPostal) => {
        const { showAlert, enableSpinner, model } = this.props;
        if (!codigoPostal) {
            showAlert({ type: 'info', message: 'No hay un Codigo postal' });
            return;
        }
        this.setState({
            isSearchCodigoPostal: true,
        });
        enableSpinner(true);
        let codigoPostalSATResponse = await apiClient.getCodigoPostalSAT(codigoPostal);
        enableSpinner(false);

        if (codigoPostalSATResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        if (codigoPostalSATResponse.status === SERVICE_RESPONSE.SUCCESS) {
            model.Pais = codigoPostalSATResponse.data.direccion[0] ? codigoPostalSATResponse.data.direccion[0].c_Pais : '';
            model.Estado = codigoPostalSATResponse.data.direccion[0] ? codigoPostalSATResponse.data.direccion[0].c_Estado : '';
            model.Municipio = codigoPostalSATResponse.data.direccion[0] ? codigoPostalSATResponse.data.direccion[0].c_Municipio : '';
            this.refreshModel(model);
            this.setState({
                localidades: codigoPostalSATResponse.data.localidades,
                colonias: codigoPostalSATResponse.data.colonias,
                municipios: codigoPostalSATResponse.data.municipios,
            });
        }
    }
    //#endregion

    restartTabs = () => {
        $('#nav-profile-tab-GeneralDriver').removeClass('active');
        $('#nav-profile-tab-DomicilioDriver').removeClass('active');
        $('#nav-profile-tab-ParteTransporteDriver').removeClass('active');

        $('#nav-profile-tab-GeneralDriver').removeClass('nav-link-current');
        $('#nav-profile-tab-DomicilioDriver').removeClass('nav-link-current');
        $('#nav-profile-tab-ParteTransporteDriver').removeClass('nav-link-current');

        $('#DatosMaestrosGeneralDriver').removeClass('active');
        $('#DomicilioDriver').removeClass('active');
        $('#PartesTransporteDriver').removeClass('active');

        $('#DatosMaestrosGeneralDriver').removeClass('show');
        $('#DomicilioDriver').removeClass('show');
        $('#PartesTransporteDriver').removeClass('show');

        $('#nav-profile-tab-GeneralDriver').addClass('active');
        $('#DatosMaestrosGeneralDriver').addClass('active')
        $('#DatosMaestrosGeneralDriver').addClass('show')
    };

    closeModal = () => {
        const { model } = this.props;
        $('#FiguraTransporte').modal('hide');
        this.openCloseAgreeModal(false);
        this.refreshModel(new TiposFigura());
        this.setState({
            municipios: [],
            localidades: [],
            colonias: [],
            isSearchCodigoPostal: false,
            showPsw: false
        });
        this.restartTabs();
    }

    openCloseAgreeModal = async (status) => {
        await this.setState({ showAreYouAgreeModal: status });
        if (status) $('#areYouAgreeModal').modal('show');
        else $('#areYouAgreeModal').modal('hide');
    }

    //#region CRUD
    sendModel = () => {
        const { sendModel, model } = this.props;
        if (this.validateModel()) {
            sendModel(model);
            this.restartTabs();
        }
    };

    deleteModel = () => {
        // const {deleteModel, model} = this.props;
        // deleteModel(model.Codigo);
        $('#confirmModalCartaPorte').modal('show');
        this.restartTabs();
    };

    acceptEditMode = () => {
        const { acceptEditMode, model } = this.props;
        this.openCloseAgreeModal(false);
        if (this.validateModel()) {
            acceptEditMode(model);
        }
    };

    cancelEditMode = () => {
        const { model, cancelEditMode } = this.props;
        this.openCloseAgreeModal(false);
        cancelEditMode();
        this.setState({
            editMode: false,
        });
    };

    editMode = () => {
        const { model } = this.props;
        this.setState({
            editMode: !this.state.editMode,
        });
    };
    //#endregion

    //#region FieldModel
    GetStates = async (pais) => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        let stateSATResponse = await apiClient.getStateSAT(pais);
        enableSpinner(false);
        this.setState({ states: stateSATResponse.data });
    }

    ShowPassword() {
        this.setState({
            showPsw: !this.state.showPsw
        })
    }

    changeFieldModel = async (model, key, event) => {
        const { showAlert, enableSpinner } = this.props;


        // if (key === 'NumLicencia') {
        //     if (isNaN(event.nativeEvent.target.value)) {
        //         showAlert({ type: 'warning', message: 'El Número de licencia solo permite números' });
        //         return;
        //     }
        // }
        if (key === 'CodigoPostal') {
            if (isNaN(event.nativeEvent.target.value)) {
                showAlert({ type: 'warning', message: 'El código postal solo permite números' });
                return;
            }
        }
        // if (key === 'NumeroInterior') {
        //     if (isNaN(event.nativeEvent.target.value)) {
        //         showAlert({ type: 'warning', message: 'El número interior solo permite números' });
        //         return;
        //     }
        // }
        if (key === 'NumeroExterior') {
            if (isNaN(event.nativeEvent.target.value)) {
                showAlert({ type: 'warning', message: 'El número exterior solo permite números' });
                return;
            }
        }


        model[key] = event.nativeEvent.target.value;

        if (key === 'CodigoPostal') {
            model.Colonia = '';
            model.Localidad = '';
            model.Referencia = '';
            model.Municipio = '';
            model.Estado = '';
            model.Pais = '';
        } else if (key === 'Pais') {
            model.Colonia = '';
            model.Localidad = '';
            model.Referencia = '';
            model.Municipio = '';
            model.Estado = '';
        } else if (key === 'Estado') {
            model.Colonia = '';
            model.Localidad = '';
            model.Referencia = '';
            model.Municipio = '';
        } else if (key === 'Municipio') {
            model.Colonia = '';
            model.Localidad = '';
            model.Referencia = '';
        } else if (key === 'Colonia') {
            const colonia = this.state?.colonias?.find(({ c_Colonia }) => c_Colonia === model.Colonia);
            if (colonia) { model.CodigoPostal = colonia.c_CodigoPostal ?? model.CodigoPostal; }
        }


        this.refreshModel(model);

        if (key === 'Pais') {
            await this.GetStates(model.Pais);
        } else if (key === 'Estado') {
            enableSpinner(true);
            const responseApi = await apiClient.getMunicipioSAT(event.nativeEvent.target.value);
            const districtData = await apiClient.getLocalidadSAT(event.nativeEvent.target.value ?? '');
            enableSpinner(false);
            if (responseApi.status) {
                await this.setState({
                    municipios: responseApi.data ?? [],
                    localidades: districtData.data ?? []
                })
            }
        } else if (key === 'Municipio') {
            this.setState({ colonias: [] });
            enableSpinner(true);
            const responseApi = await apiClient.getAddressDetailSAT({ action: 'getTowns', state: model.Estado, municipality: model.Municipio, district: model.Localidad });
            if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
                this.setState({ colonias: await this.FilterArrayDoubleValues('Colonias', responseApi.data) ?? [] });
            }
            enableSpinner(false);
        }

    };


    FilterArrayDoubleValues = (propertyCompare, array) => {
        const uniqueIds = {};
        const resultado = [];
        array.forEach(obj => {
            if (!uniqueIds[obj[propertyCompare]]) {
                uniqueIds[obj[propertyCompare]] = true;
                resultado.push(obj);
            }
        });
        return resultado;
    }

    changeFieldArrayModel = (model, key, subKey, index, event) => {
        model[key][index][subKey] = event.nativeEvent.target.value;
        this.refreshModel(model);
    };

    addParteTransporte = () => {
        const { model } = this.props;
        if (Array.isArray(model.PartesTransporte)) {
            model.PartesTransporte.push({ ParteTransporte: '' });
        } else {
            model.PartesTransporte = [];
            model.PartesTransporte.push({ ParteTransporte: '' });
        }
        this.refreshModel(model);
    }

    removeParteTransporte = (index) => {
        const { model } = this.props;
        model.PartesTransporte.splice(index, 1);
        this.refreshModel(model);
    }

    // Validar campos requeridos
    validateModel = () => {
        const { model, showAlert } = this.props;
        return true;//OMITIR VALIDACIONES POR AHORA
        if (model.NombreFigura === undefined || model.NombreFigura === '') {
            showAlert({ type: 'warning', message: 'El campo NombreFigura no puede estar vacío' });
            return false;
        }
        if (model.TipoFigura === undefined || model.TipoFigura === '') {
            showAlert({ type: 'warning', message: 'Seleccione un TipoFigura para poder continuar' });
            return false;
        }
        if (model.RFC === undefined || model.RFC === '') {
            showAlert({ type: 'warning', message: 'El campo RUT no puede estar vacío' });
            return false;
        }
        if (model.RFC.length < 12) {
            showAlert({ type: 'warning', message: 'El campo RUT debe tener más de 11 caracteres' });
            return false;
        }
        if (model.NumRegIdTrib !== undefined && model.NumRegIdTrib !== '') {
            if (model.ResidenciaFiscalFigura === undefined || model.ResidenciaFiscalFigura === '') {
                showAlert({ type: 'warning', message: 'El campo ResidenciaFiscal no puede estar vacío' });
                return false;
            }
        }

        if (model.NumLicencia === undefined || model.NumLicencia === '') {
            showAlert({ type: 'warning', message: 'El campo NumLicencia no puede estar vacío' });
            return false;
        }

        if (model.TipoFigura === '02' || model.TipoFigura === '03') {
            if (model.PartesTransporte) {
                model.PartesTransporte.forEach((element, index) => {
                    if (element.ParteTransporte === undefined || element.ParteTransporte === '') {
                        showAlert({ type: 'warning', message: 'El campo ParteTransporte no puede estar vacío, posición ' + (index + 1) });
                        return false;
                    }
                });
            }
        }

        if (model.Calle === undefined || model.Calle === '') {
            showAlert({ type: 'warning', message: 'El campo Calle no puede estar vacío' });
            return false;
        }

        // if (model.NumeroInterior === undefined || model.NumeroInterior === '') {
        //     showAlert({ type: 'warning', message: 'El Número Interior no puede estar vacío' });
        //     return false;
        // }

        if (model.CodigoPostal === undefined || model.CodigoPostal === '') {
            showAlert({ type: 'warning', message: 'El campo CodigoPostal no puede estar vacío' });
            return false;
        }

        if (model.Estado === undefined || model.Estado === '') {
            showAlert({ type: 'warning', message: 'El campo Estado no puede estar vacío' });
            return false;
        }

        if (model.Localidad === undefined || model.Localidad === '') {
            showAlert({ type: 'warning', message: 'El campo Localidad no puede estar vacío' });
            return false;
        }

        if (model.NumeroExterior === undefined || model.NumeroExterior === '') {
            showAlert({ type: 'warning', message: 'El campo Número Exterior no puede estar vacío' });
            return false;
        }

        // if (model.Referencia === undefined || model.Referencia === '') {
        //     showAlert({ type: 'warning', message: 'El campo Referencia no puede estar vacío' });
        //     return false;
        // }

        if (model.Pais === undefined || model.Pais === '') {
            showAlert({ type: 'warning', message: 'El campo País no puede estar vacío' });
            return false;
        }

        if (model.Municipio === undefined || model.Municipio === '') {
            showAlert({ type: 'warning', message: 'El campo Municipio no puede estar vacío' });
            return false;
        }

        if (model.Colonia === undefined || model.Colonia === '') {
            showAlert({ type: 'warning', message: 'El campo Colonia no puede estar vacío' });
            return false;
        }
        return true;
    };

    refreshModel = model => {
        const { refreshModel } = this.props;
        refreshModel(model);
    };
    //#endregion

    //#region Render
    renderEditButton = () => {
        const { action, view } = this.props;
        const { editMode } = this.state;
        if (action === 2 && !editMode && view !== 'consignmentNote') {
            return (
                <button
                    type="button"
                    style={{ backgroundColor: 'transparent', color: '#000' }}
                    className="btn btn-editar"
                    onClick={this.editMode}>
                    <i className="fas fa-edit  fa-lg" />
                    Editar
                </button>
            );
        }
    };

    renderDriverHeader = () => {
        const { model, action } = this.props;
        const { editMode, showPsw, sucursales, availableVehicles } = this.state;

        return (
            <div className="row">
                {/*PRIMER COLUMNA*/}

                <div className="col-12 col-md-6">
                    {/*CÓDIGO DE DRIVER MANAGER*/}
                    {(action !== 1 && !editMode) && <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Código</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtCardCode"
                            disabled={(action === 2 || action === 1) && !editMode ? true : false}
                            //    onChange={this.changeDriverCodigo}
                            value={model.CodigoFiguraTransporte ? model.CodigoFiguraTransporte : ""}
                        />
                    </div>}

                    {/*NOMBRE DE DRIVER MANAGER*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">NombreFigura</span>
                                <span className="d-inline d-xl-none">Nombre</span>
                            </span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtCardName"
                            disabled={(action === 2 && !editMode) ? true : false}
                            maxLength={254}
                            //    onChange={this.changeDriverNombreFigura}
                            onChange={(event) => this.changeFieldModel(model, "NombreFigura", event)}
                            value={model.NombreFigura ? model.NombreFigura : ""}
                        />
                    </div>
                    {/*Email*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Email</span>
                        </div>
                        <input
                            type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtEmail"
                            disabled={(action === 2 && !editMode) ? true : false}
                            maxLength={254}
                            //    onChange={this.changeDriverNombreFigura}
                            onChange={(event) => this.changeFieldModel(model, "Email", event)}
                            value={model.Email ? model.Email : ""}
                        />
                    </div>
                    {/*CONTRASEÑA*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Contraseña</span>
                        </div>
                        <input
                            type={showPsw ? "text" : "password"}
                            className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtPager"
                            disabled={(action === 2 && !editMode) ? true : false}
                            maxLength={254}
                            //    onChange={this.changeDriverNombreFigura}
                            onChange={(event) => this.changeFieldModel(model, "Password", event)}
                            value={model.Password ? model.Password : ""}
                        />
                        <div id="eyePswTransport" className="input-group-prepend" style={{ width: 40 }}>
                            <span className="input-group-text" style={{ background: '' }}
                                onClick={() => this.ShowPassword()}><i className={showPsw ? 'fa fa-eye' : 'fa fa-eye-slash'} /></span>
                        </div>

                    </div>

                </div>

                {/*SEGUNDA COLUMNA*/}

                <div className="col-12 col-md-6">

                    {/*TIPO FIGURA DRIVER MANAGER*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">TipoFigura</span>
                                <span className="d-inline d-xl-none">Tipo</span>
                            </span>
                        </div>
                        <Select
                            id="txtGroupCode"
                            className="p-0 border-0"
                            classNamePrefix="react-select"
                            options={[
                                { value: '', label: 'Seleccione una opción' },
                                { value: '01', label: '01. Llamagas' },
                                { value: '02', label: '02. Propietario' },
                                { value: '03', label: '03. Arrendador' },
                                { value: '04', label: '04. Notificado' },
                                { value: '05', label: '05. Externo' }
                            ]}
                            value={[
                                { value: '', label: 'Seleccione una opción' },
                                { value: '01', label: '01. Llamagas' },
                                { value: '02', label: '02. Propietario' },
                                { value: '03', label: '03. Arrendador' },
                                { value: '04', label: '04. Notificado' },
                                { value: '05', label: '05. Externo' }
                            ].find(
                                option => option.value === (model.TipoFigura ? model.TipoFigura.trim() : '')
                            ) || null}
                            onChange={(selected) =>
                                this.changeFieldModel(
                                    model,
                                    "TipoFigura",
                                    {
                                        nativeEvent: {
                                            target: {
                                                value: selected ? selected.value : ''
                                            }
                                        }
                                    }
                                )
                            }
                            isDisabled={(action === 2 && !editMode) ? true : false}
                            isSearchable={true}
                            isClearable={false}
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                            styles={customSelectStyles}
                        />
                    </div>

                    {/*RFC DRIVER MANAGER*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">RUT</span>
                        </div>
                        <input type="text" className="form-control input-sm"
                            id="txtGroupCode"
                            maxLength={13}
                            disabled={(action === 2 && !editMode) ? true : false}
                            onChange={(event) => this.changeFieldModel(model, "RFC", event)}
                            value={model.RFC ? model.RFC : ""}
                        />
                    </div>

                    {/*SUCURSAL*/}
                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Sucursal</span>
                        </div>
                        <select
                            name="select"
                            className="form-control"
                            id="selectDocTypeDocumentSearch"
                            disabled={(action === 2 && !editMode) ? true : false}
                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                            value={model.U_FMB_Sucursal ? model.U_FMB_Sucursal : ""}
                            onChange={(event) => this.changeFieldModel(model, "U_FMB_Sucursal", event)}
                        >
                            <option value="---">Selecciona sucursal</option>
                            {sucursales && sucursales.map((sucur, index) => {
                                return (
                                    <option key={'optionSuc' + index} value={sucur.pk_Sucursal}>{sucur.nombre}</option>
                                )
                            })}
                        </select>
                    </div> */}

                    {/*TRANSPORTE*/}
                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Placa</span>
                        </div>
                        <select
                            name="select"
                            className="form-control"
                            id="selectDocTypeDocumentSearch"
                            disabled={(action === 2 && !editMode) ? true : false}
                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                            value={model.IdVHCL ? model.IdVHCL : ""}
                            onChange={(event) => this.changeFieldModel(model, "IdVHCL", event)}
                        >
                            <option value="-1">Selecciona la placa</option>
                            {availableVehicles && availableVehicles.map((vehicle, index) => {
                                return (
                                    <option key={'optionVehicle' + index} value={vehicle.CodigoAutotransporte}>{vehicle.PlacaVM}</option>
                                )
                            })}
                        </select>
                    </div> */}

                </div>

                <br></br>
            </div>
        )
    }

    renderDriverBody = () => {
        const { model, action, countries } = this.props;
        const { editMode, parteTransporte, states, municipios, localidades, colonias, isSearchCodigoPostal } = this.state;
        // console.log('con<######### model ', model)
        return (
            <div style={{ marginTop: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-profile-tab-GeneralDriver"
                            data-toggle="tab"
                            href="#DatosMaestrosGeneralDriver"
                            role="generalDriver"
                            aria-controls="DatosMaestrosGeneralDriver"
                            aria-selected="true">
                            General
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-DomicilioDriver"
                            data-toggle="tab"
                            href="#DomicilioDriver"
                            role="domicilioDriver"
                            aria-controls="DomicilioDriver"
                            aria-selected="false">
                            Domicilio
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-ParteTransporteDriver"
                            data-toggle="tab"
                            href="#PartesTransporteDriver"
                            role="partesTransporteoDriver"
                            aria-controls="PartesTransporteDriver"
                            aria-selected="false"
                            style={{ display: (model.TipoFigura.trim() !== '02' && model.TipoFigura.trim() !== '03' && model.TipoFigura.trim() !== '05') ? "none" : "" }}
                        >
                            PartesTransporte
                        </a>
                    </div>
                </nav>

                <div className="tab-content" style={{ textAlign: 'left' }}>
                    {/* APARTADO GENRAL */}
                    <div className="container tab-pane active"
                        id="DatosMaestrosGeneralDriver"
                        role="generalDriver"
                        aria-labelledby="nav-profile-tab-GeneralDriver"
                    //  style={{maxHeight: 500}}
                    >
                        {/*Primera columna*/}
                        <div className="row">
                            <div className="col-12 col-md-6">
                                {/*NumLicencia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">NumLicencia</span>
                                            <span className="d-inline d-xl-none">Núm Licencia</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="txtTel1"
                                        maxLength={16}
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(model, "NumLicencia", event)}
                                        value={model.NumLicencia ? model.NumLicencia : ""}
                                    />
                                </div>
                            </div>

                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6"> 
                                {/*NumRegIdTrib*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">NumRegIdTrib</span>
                                            <span className="d-inline d-xl-none">Reg Tributario</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        maxLength={40}
                                        onChange={(event) => this.changeFieldModel(model, "NumRegIdTrib", event)}
                                        value={model.NumRegIdTrib ? model.NumRegIdTrib : ""}
                                        id="txtTel2" />
                                </div>

                                {/*ResidenciaFiscalFigura*/}
                                <div className="input-group mb-3" style={{ display: model.NumRegIdTrib !== '' ? '' : 'none' }}>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">ResidenciaFiscalFigura</span>
                                            <span className="d-inline d-xl-none">Res Fiscal</span>
                                        </span>
                                    </div>
                                    <select id="txtGroupCode" className="form-control btn-outline-secondary" value={model.ResidenciaFiscalFigura ? model.ResidenciaFiscalFigura.trim() : ""}
                                        onChange={(event) => this.changeFieldModel(model, "ResidenciaFiscalFigura", event)}
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                        <option value=''>Seleccione una opción</option>
                                        {!!countries && countries.map((dato => {
                                            return (
                                                <option value={dato.c_Pais}>{dato.Nombre}</option>
                                            );
                                        }))}
                                    </select>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* APARTADO Domicilio */}
                    <div className="container tab-pane fade"
                        id="DomicilioDriver"
                        role="domicilioDriver"
                        aria-labelledby="nav-profile-tab-DomicilioDriver" >
                        <div className="row">
                            <div className="col-12 col-md-6">
                                {/*Street*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Calle</span>
                                    </div>
                                    <input type="text" className="form-control btn-outline-secondary"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        maxLength={5000}
                                        value={model.Calle ? model.Calle : ""}
                                        onChange={(event) => this.changeFieldModel(model, "Calle", event)}
                                        id="txtTel2" />
                                </div>

                                {/*StreetNo*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">NumeroInterior</span>
                                            <span className="d-inline d-xl-none">Núm Interior</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control btn-outline-secondary"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        value={model.NumeroInterior ? model.NumeroInterior : ""}
                                        maxLength={10}
                                        placeholder='Opcional'
                                        onChange={(event) => this.changeFieldModel(model, "NumeroInterior", event)}
                                        id="txtTel2" />
                                </div>

                                {/*ZipCode*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Código Postal</span>
                                            <span className="d-inline d-xl-none">Código Postal</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control btn-outline-secondary"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        maxLength={5}
                                        onKeyPress={(eve) => {
                                            if (eve.key === 'Enter') {
                                                this.getCodigoPostalSAT(model.CodigoPostal);
                                            }
                                        }}
                                        value={model.CodigoPostal !== undefined ? model.CodigoPostal : ""}
                                        onChange={(event) => this.changeFieldModel(model, "CodigoPostal", event)}
                                        id="txtTel2" />
                                    <button type="button" className="input-group-text"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        onClick={() => { this.getCodigoPostalSAT(model.CodigoPostal) }}>
                                        <i className="fas fa-search-location fa-lg" />
                                    </button>
                                </div>

                                {/*Estado */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                                    </div>
                                    {model && model.Pais !== '' && model.Pais !== 'MEX' ?
                                        <input type="text" className="form-control"
                                            disabled={((!isSearchCodigoPostal || action === 2) && !editMode) ? true : false}
                                            value={model.Estado ? model.Estado : ""}
                                            onChange={(event) => this.changeFieldModel(model, "Estado", event)}
                                            id="txtTel2" />
                                        :
                                        <select id="txtGroupCode" className="form-control" value={model.Estado ? model.Estado : ""}
                                            onChange={(event) => this.changeFieldModel(model, "Estado", event)}
                                            disabled={(action === 2 && !editMode) || !model.Pais}
                                        >
                                            <option value=''>Seleccione una opción</option>
                                            {!!states && states.map((dato => {
                                                return (
                                                    <option value={dato.c_Estado}>{dato?.Nombre ?? dato?.Estado}</option>
                                                );
                                            }))}
                                        </select>
                                    }
                                </div>

                                {/*Localidad*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Localidad</span>
                                    </div>
                                    {model && model.Pais !== '' && model.Pais !== 'MEX' ?
                                        <input type="text" className="form-control"
                                            // style={{  backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                            disabled={(!(isSearchCodigoPostal || action === 2) && !editMode) ? true : false}
                                            value={model.Localidad ? model.Localidad : ""}
                                            onChange={(event) => this.changeFieldModel(model, "Localidad", event)}
                                            id="txtTel2" />
                                        :
                                        <select id="txtGroupCode" className="form-control" value={model.Localidad ? model.Localidad : ""}
                                            onChange={(event) => this.changeFieldModel(model, "Localidad", event)}
                                            disabled={(action === 2 && !editMode) || !model.Municipio}
                                        // style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                        >
                                            <option value=''>Seleccione una opción</option>
                                            {!!localidades && localidades.map((dato => {
                                                return (
                                                    <option value={dato.c_Localidad}>{dato.Nombre ?? dato.Localidad}</option>
                                                );
                                            }))}
                                        </select>
                                    }
                                </div>

                            </div>

                            {/*segunda columna*/}
                            <div className="col-12 col-md-6">
                                {/*StreetNo*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">NumeroExterior</span>
                                            <span className="d-inline d-xl-none">Núm Exterior</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control btn-outline-secondary"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        maxLength={10}
                                        value={model.NumeroExterior ? model.NumeroExterior : ""}
                                        onChange={(event) => this.changeFieldModel(model, "NumeroExterior", event)}
                                        id="txtTel2" />
                                </div>

                                {/*Reference*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Referencia</span>
                                    </div>
                                    <input type="text" className="form-control btn-outline-secondary"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        maxLength={5000}
                                        placeholder='Opcional'
                                        value={model.Referencia ? model.Referencia : ""}
                                        onChange={(event) => this.changeFieldModel(model, "Referencia", event)}
                                        id="txtTel2" />
                                </div>

                                {/*Country*/}

                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">País</span>
                                    </div>

                                    <select id="txtGroupCode" className="form-control" value={model.Pais ? model.Pais : ""}
                                        onChange={(event) => this.changeFieldModel(model, "Pais", event)}
                                        disabled={action === 2 && !editMode}
                                    // disabled={(action == 2 && !editMode) ? true : false}
                                    // style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                    >
                                        <option value=''>Seleccione una opción</option>
                                        <option value='MEX'>México</option>
                                        {/* {!!countries && countries.map((dato => {
                                            return (
                                                <option value={dato.c_Pais}>{dato.Nombre}</option>
                                            );
                                        }))} */}
                                    </select>
                                </div>

                                {/*County*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Municipio</span>
                                    </div>
                                    {model && model.Pais !== '' && model.Pais !== 'MEX' ?
                                        <input type="text" className="form-control"
                                            // style={{backgroundColor: 'transparent',borderColor: '#ced4da', color: '#000' }}
                                            disabled={action === 2 && !editMode}
                                            value={model.Municipio ? model.Municipio : ""}
                                            onChange={(event) => this.changeFieldModel(model, "Municipio", event)}
                                            id="txtTel2" />
                                        :
                                        <select id="txtGroupCode" className="form-control" value={model.Municipio ? model.Municipio : ""}
                                            onChange={(event) => this.changeFieldModel(model, "Municipio", event)}
                                            disabled={(action === 2 && !editMode) || !model.Estado}
                                        // disabled={(action == 2 && !editMode) ? true : false}
                                        // style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                        >
                                            <option value=''>Seleccione una opción</option>
                                            {!!municipios && municipios.map((dato => {
                                                return (
                                                    <option value={dato.c_Municipio}>{dato.Nombre ?? dato.Municipio}</option>
                                                );
                                            }))}
                                        </select>
                                    }
                                </div>

                                {/*Colonia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Colonia</span>
                                    </div>
                                    {model && model.Pais !== '' && model.Pais !== 'MEX' ?
                                        <input type="text" className="form-control"
                                            // style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                            // disabled={(action == 2 && !editMode) ? true : false}
                                            disabled={action === 2 && !editMode}
                                            value={model.Colonia ? model.Colonia : ""}
                                            onChange={(event) => this.changeFieldModel(model, "Colonia", event)}
                                            id="txtTel2" />
                                        :
                                        <select id="txtGroupCode" className="form-control" value={model.Colonia ? model.Colonia : ""}
                                            onChange={(event) => this.changeFieldModel(model, "Colonia", event)}
                                            disabled={(action === 2 && !editMode) || !model.Municipio}
                                        // style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                        >
                                            <option value=''>Seleccione una opción</option>
                                            {!!colonias && colonias.map((dato => {
                                                return (
                                                    <option value={dato.c_Colonia}>{dato.Nombre ?? dato.Colonias}</option>
                                                );
                                            }))}
                                        </select>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* APARTADO PartesTransporte */}
                    {!(model.TipoFigura.trim() !== "02" && model.TipoFigura.trim() !== "03" && model.TipoFigura.trim() !== "05") &&
                        <div className="container tab-pane fade"
                            id="PartesTransporteDriver"
                            role="partesTransporteoDriver"
                            aria-labelledby="nav-profile-tab-ParteTransporteDriver"
                        //  style={{maxHeight: 500}}
                        >
                            {/*Primera columna*/}
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    {/*ParteTransporte*/}
                                    {!!model.PartesTransporte && model.PartesTransporte.map((element, index) => {
                                        return (
                                            <div className="input-group mb-3" key={index}>
                                                {/*Eliminar*/}
                                                {((action === 1 && editMode !== true) || (action === 2 && editMode)) && <button
                                                    type="button"
                                                    style={{ backgroundColor: 'transparent', padding: 5, textAlign: "center", color: '#c42222' }}
                                                    className="btn"
                                                    onClick={() => this.removeParteTransporte(index)}>
                                                    <i className="fas fa-trash-alt"
                                                        aria-hidden="true" size="10" />
                                                </button>}
                                                <div className="input-group-prepend cfdi-res">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                    <span className="d-none d-xl-inline">ParteTransporte</span>
                                                    <span className="d-inline d-xl-none">Parte Transporte</span>
                                                </span>
                                                </div>
                                                <select id={index} className="form-control btn-outline-secondary"
                                                    value={element.ParteTransporte ? element.ParteTransporte : ""}
                                                    onChange={(event) => this.changeFieldArrayModel(model, "PartesTransporte", "ParteTransporte", index, event)}
                                                    disabled={(action === 2 && !editMode) ? true : false}
                                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                                    <option value=''>Seleccione una opción</option>
                                                    {!!parteTransporte && parteTransporte.map(((dato) => {
                                                        return (
                                                            <option value={dato.Clave}>{dato.Clave}. {dato.Descripcion}</option>
                                                        );
                                                    }))}
                                                </select>
                                            </div>
                                        )
                                    })
                                    }

                                </div>

                                {/*Segunda columna*/}
                                <div className="col-12 col-md-6">

                                    {/*Añadir ParteTransporte*/}
                                    {((action === 1 && editMode !== true) || (action === 2 && editMode)) &&
                                        <div className="input-group mb-3">
                                            <button type="button" className="btn botonCerrar text-white" onClick={this.addParteTransporte} >{"Añadir ParteTransporte"}</button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>}
                </div>
            </div>
        )
    }

    render() {
        const { action, model, acceptDeleteModel } = this.props;
        const { editMode, showAreYouAgreeModal, isSearchCodigoPostal } = this.state;
        if (model.CodigoPostal !== "" && model.CodigoPostal !== undefined) {
            if (!isSearchCodigoPostal && action == 2) {
                this.getCodigoPostalSAT(model.CodigoPostal);
            }
        }
        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll"
                id="FiguraTransporte"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true">

                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">DATOS FIGURA TRANSPORTE</h4>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                {this.renderEditButton()}
                                                {this.renderDriverHeader()}
                                                {this.renderDriverBody()}<br></br><br></br>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">

                            {/* {action != 1 && !editMode && view !== 'consignmentNote' && (
                                <button type="button" className="btn botonCerrar text-white" style={{ background: '#c42222 !important' }} onClick={this.deleteModel}>
                                    Eliminar
                                </button>
                            )} */}

                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}>Cerrar
                            </button>
                            {action === 1 && <button type="button" className="btn botonCorrect text-black"
                                onClick={this.sendModel}> Crear</button>}
                            {action === 2 && editMode && (
                                <button type="button" className="btn btn-danger text-white" onClick={() => this.openCloseAgreeModal(true)}>
                                    Eliminar
                                </button>
                            )}
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.acceptEditMode}>
                                    Guardar
                                </button>
                            )}

                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.cancelEditMode}>
                                    Cancelar
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {showAreYouAgreeModal && <AreYouAgreeModal
                    mensaje={'¿Seguro que deseas eliminar esta figura de transporte?'}
                    accept={acceptDeleteModel}
                    cancel={() => this.openCloseAgreeModal(false)}
                />}
                {/* {this.openAction()} */}
            </div>
        );
    }

    //#endregion
}

export default FiguraTransporteModal;